export const emptyStateTokens = {
  'empty-padding': 'var(--dp-spacing-xxl)',
  'empty-icon-size': '64px',
  'empty-icon-color': 'var(--dp-color-text-tertiary)',
  'empty-title-font-size': 'var(--dp-font-size-lg)',
  'empty-title-color': 'var(--dp-color-text)',
  'empty-description-color': 'var(--dp-color-text-secondary)',
  'empty-action-margin-top': 'var(--dp-spacing-lg)',
  'empty-max-width': '400px',
} as const;
